import React, { useState } from 'react';
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom';
import './HamburgerMenu.css';

const HamburgerMenu = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

  const userType = Cookies.get('userType')
    return (
        <div className="hamburger-menu">
            <button className="menu-button" onClick={toggleMenu}>
                ☰
            </button>
            <nav className={`nav-links ${isOpen ? 'open' : ''}`}>
                {userType !== 'adminViewOnly' && <Link to="/coach" onClick={toggleMenu}>Coach</Link>}
                {(userType === 'admin' || userType === 'adminViewOnly' || userType === 'owner') && <Link to="/programs" onClick={toggleMenu}>Programs</Link>}
                {(userType === 'admin' || userType === 'owner') && <Link to="/staff" onClick={toggleMenu}>Staff</Link>}
                {(userType === 'admin' || userType === 'owner') && <Link to="/metrics" onClick={toggleMenu}>Metrics</Link>}
                {(userType === 'admin' || userType === 'owner') && <Link to="/payroll" onClick={toggleMenu}>Payroll</Link>}
                {(userType === 'admin' || userType === 'owner') && <Link to="/retention" onClick={toggleMenu}>Retention</Link>}
                {(userType === 'admin' || userType === 'owner') && <Link to="/break-even" onClick={toggleMenu}>Break-Even</Link>}
            </nav>
        </div>
    );
};

export default HamburgerMenu;